export default "__VITE_ASSET__C5DY3PGl__"